import '.di{outline:none;}.ssr-plugin'
import '.e9{padding:0px;}.ssr-plugin'
import '.dj{cursor:pointer;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.f0{transition:all .2s ease-out;}.ssr-plugin'
import '.f1{scale:1;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { transparentColor } from '../utils/transparentcolor.js'
import { colors } from '../utils/colors.js'

type IconButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  icon: React.ReactNode
  variant?: 'fill' | 'ghost'
  size?: 'small' | 'large'
  style?: Style
  id?: string
  ariaLabel?: string
}

export const IconButton = ({
  onClick,
  icon,
  variant = 'fill',
  size = 'small',
  style,
  id,
  ariaLabel,
}: IconButtonProps) => {
  const dimension = size === 'large' ? 50 : 32
  return (
    <styled.button className="di e9 dj e w cy f0 f1"
      onClick={onClick}
      id={id}
      aria-label={ariaLabel}
      style={
        {
          background:
            variant === 'ghost'
              ? 'transparent'
              : transparentColor(colors.white, 0.25),
          border:
            variant === 'fill'
              ? `solid 1px ${colors.border}`
              : 'solid 1px transparent',
          backdropFilter: variant === 'fill' ? 'blur(8px)' : 'none',
          WebkitBackdropFilter: variant === 'fill' ? 'blur(8px)' : 'none',
          borderRadius: dimension,
          width: dimension,
          height: dimension,
          '&:hover': {
            scale: 0.92,
            border: `solid 1px ${colors.border}`,
            background:
              variant === 'fill'
                ? `${transparentColor(colors.white, 0.25)}`
                : `${transparentColor(colors.white, 0.2)}`,
          },
          "html[dir='rtl'] & svg": {
            transform: 'scaleX(-1)',
          },
          ...style,
        } as Style
      }
    >
      {icon}
    </styled.button>
  )
}
